import './BtnMouse.css';

function BtnMouse() {
  return (
    <>
    <a href="#skills" className="mouse-scroll-icon visible"><svg width='50' viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-label='Button Mouse' role='img'>
    <g fill="none" stroke="#6b7280" strokeLinejoin="round" >
        <path d="M6 9a6 6 0 0 1 12 0v6a6 6 0 0 1-12 0V9Z"/>
        <path strokeLinecap="round" d="M12 7v4"/>
    </g>
</svg></a>
      
    </>
  );
}

export default BtnMouse;
